import Vue from "vue";
import "./plugins/vuetify";

// Plugins
// -------------------------------------------------------------------
import "@/plugins/iview";
import "@/plugins/vuetify";
import "@/plugins/casl";
import "@/plugins/current_user";
import "@/plugins/http";
import "@/plugins/ag-grid";
import "@/plugins/toast";
import "@/plugins/clipboard";
import "@/plugins/google_map";
import "@/plugins/current_user";

// Application
// -------------------------------------------------------------------
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";

// ----------------------------------------------------------------------
// Event Bus
// TODO: to be deprecated, components should be rewritten
// ----------------------------------------------------------------------
// @ts-ignore
window.EventBus = new Vue();

Vue.config.productionTip = false;

// ----------------------------------------------------------------------
// Main application
// ----------------------------------------------------------------------
const app = new Vue({
  router,
  store,
  el: "#app",
  render: h => h(App),
  created() {
    this.$store.dispatch("login", {});
  },
});
// .$mount("#app");

// ----------------------------------------------------------------------
// E2E Testing
// ----------------------------------------------------------------------
// if (window.Cypress) {
// only available during E2E tests
// window.app = app;
// }
